import React, { useId } from 'react';
import css from './customer.module.scss';
import AnimatedContainer from 'src/components/animated-container/animated-container';
import { ReactComponent as CmtrLogo } from 'src/assets/general/cmtr.svg';
import { ReactComponent as GshLogo } from 'src/assets/general/gsh.svg';
import { openInNewTab } from 'src/utils/helper';

export default function Customer() {
  const customerKey = useId();
  const customers = [
    { logo: <GshLogo />, url: 'https://www.zsu.gov.ua/' },
    { logo: <CmtrLogo />, url: 'https://www.facebook.com/TSCAFU/' }
  ];

  return (
    <div className={css.customers}>
      <div className={css.container}>
        <header>
          <h2>Створено за ініціативи</h2>
        </header>

        {customers.map((customer, i) => (
          <AnimatedContainer key={customerKey + i} onClick={() => openInNewTab(customer.url)} /* NOSONAR */>
            {customer.logo}
          </AnimatedContainer>
        ))}
      </div>
    </div>
  );
}
